/**
 * Umbrales DRL orientativos (DLP mGy·cm para CT; DAP µGy·m² / mGy·cm² para RX).
 * Ajustables sin tocar UI. No sustituyen normativa local.
 */

export const DRL_THRESHOLDS = {
  CT_HEAD: { dlpCaution: 800, dlpHigh: 1200, label: 'CT Cráneo' },
  CT_CHEST: { dlpCaution: 400, dlpHigh: 600, label: 'CT Tórax' },
  CT_ABDOMEN: { dlpCaution: 700, dlpHigh: 1000, label: 'CT Abdomen' },
  CT_DEFAULT: { dlpCaution: 600, dlpHigh: 1000, label: 'CT' },
  XR_DEFAULT: { dapCaution: 50, dapHigh: 100, label: 'Rayos X' },
  FL_DEFAULT: { dapCaution: 100, dapHigh: 250, label: 'Fluoroscopia' },
}

/**
 * @param {string} bodyPartOrDesc
 * @param {string} modality
 */
export function resolveDrlProfile(bodyPartOrDesc, modality) {
  const m = String(modality || '').toUpperCase()
  const d = String(bodyPartOrDesc || '').toLowerCase()
  if (m === 'CT' || m === 'MR') {
    if (/head|craneo|cráneo|brain|skull|cabeza/.test(d)) return DRL_THRESHOLDS.CT_HEAD
    if (/chest|torax|tórax|thorax|pulm/.test(d)) return DRL_THRESHOLDS.CT_CHEST
    if (/abdomen|pelvis|abd/.test(d)) return DRL_THRESHOLDS.CT_ABDOMEN
    return DRL_THRESHOLDS.CT_DEFAULT
  }
  if (m === 'RF' || m === 'XA' || m === 'XRF') return DRL_THRESHOLDS.FL_DEFAULT
  if (m === 'CR' || m === 'DX' || m === 'RG' || m === 'XA') return DRL_THRESHOLDS.XR_DEFAULT
  return DRL_THRESHOLDS.CT_DEFAULT
}

/**
 * @param {{ dlp?: number|null, dap?: number|null, modality?: string, description?: string }} report
 * @returns {'ok'|'caution'|'high'|'unknown'}
 */
export function evaluateDrlLevel(report = {}) {
  const profile = resolveDrlProfile(report.description, report.modality)
  const dlp = report.dlp
  const dap = report.dap

  if (dlp != null && Number.isFinite(dlp) && profile.dlpHigh != null) {
    if (dlp >= profile.dlpHigh) return 'high'
    if (dlp >= profile.dlpCaution) return 'caution'
    return 'ok'
  }
  if (dap != null && Number.isFinite(dap) && profile.dapHigh != null) {
    if (dap >= profile.dapHigh) return 'high'
    if (dap >= profile.dapCaution) return 'caution'
    return 'ok'
  }
  return 'unknown'
}

export function drlLevelLabel(level) {
  switch (level) {
    case 'high':
      return 'Exposición elevada'
    case 'caution':
      return 'Cerca del DRL'
    case 'ok':
      return 'Dentro de DRL'
    default:
      return 'Sin umbral'
  }
}
